import styled, { css } from 'styled-components';
import { em } from 'polished';

const ButtonBase = styled.button`
  -webkit-appearance: none;
  border: none;
  border-radius: 2px;
  font-size: ${em(16)};
  font-weight: 500;
  min-height: 40px;
  user-select: none;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  ${({hasIcon, hasLabel, adjustPosition, reverse}) => {
    const minWidth = (props) => hasLabel && css`
      min-width: 88px;
    `;
    const paddingLeft = (hasIcon && hasLabel) ? (reverse ? 8 : 16) : 16;
    const paddingRight = (hasIcon && hasLabel) ? (reverse ? 16 : 8) : 16;
    const adjustment = (props) => adjustPosition && css`
    transform: translateX(-${paddingLeft}px);
  `;
    return css`
      ${minWidth};
      padding: 0 ${em(paddingRight)} 0 ${em(paddingLeft)};
      ${adjustment}
    `;
  }}

  /**
   * <a> elements button vietā
   */
  ${({href}) => href && css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;

    & > span {
      transform: translateY(1px);
    }
  `}

  ${({hasIcon, hasLabel}) => hasIcon && !hasLabel && css`
    display: flex;
  `};

  ${({ disabled }) => disabled && css`
    pointer-events: none !important;
  `};
`;

export default ButtonBase;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/ButtonBase.js